<script>
    export default {
        props: {
            label: {
                type: String,
                default: 'auto',
            },
            count: {
                type: Number,
                required: true,
            },
            sort: {
                type: String,
                default: '',
            },
        },
    }
</script>

<template>
    <bg-column-progress :label="label" :sort="sort" :value="count" :required="1"/>
</template>
